import React from 'react'
import cx from 'classnames'

const PillBadge = ({ className, title, children }) => (
  <span
    className={cx('bg-light-silver ph2 pv1 fw7 br-pill', className)}
    title={title}
  >
    {children}
  </span>
)

export default PillBadge
